import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "reactstrap";
import classNames from "classnames";
import { getName } from "country-list";
import { useTranslation } from "react-i18next";

import Modal from "../Modal";
import {
  getCardDetails,
  getCardDetailsReset,
} from "@redux/cardDetails/actions";

import styles from "./index.module.scss";

const PaymentCardDetails = ({ id, isOpen, toggle }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation("payment-methods");
  const { t: t1 } = useTranslation("modals");

  const {
    id: cardId,
    isLoading,
    fullName,
    country,
    addressLineFirst,
    addressLineSecond,
    postalCode,
    lastFourNumbers,
    paymentSystem,
    expMonth,
    expYear,
    city,
    state,
  } = useSelector(({ cardDetailsReducer }) => cardDetailsReducer);

  useEffect(() => {
    if (isOpen && id !== cardId) {
      dispatch(getCardDetails({ id }));
    }

    return () => {
      if (id === cardId) {
        dispatch(getCardDetailsReset());
      }
    };
  }, [cardId, dispatch, id, isOpen]);

  const billingAddressVisible =
    fullName ||
    country ||
    addressLineFirst ||
    addressLineSecond ||
    city ||
    state ||
    postalCode;

  return (
    <Modal
      title={t1("PAYMENT_CARD_DETAILS_TITLE")}
      isOpen={isOpen}
      toggle={toggle}
      onCancel={toggle}
      onClose={toggle}
      size="sm"
      bodyClassName="pb-4 mb-2"
      footerClassName="d-none"
    >
      {isLoading && <Spinner className="my-4" />}
      <div className={classNames(isLoading && "d-none")}>
        {billingAddressVisible && (
          <>
            <div className="subtitle-2 text-medium mb-2 text-primary">
              {t("BILLING_ADDR")}
            </div>
            <div
              className={classNames(
                "d-flex flex-column mb-4 pb-1 text-body-1 text-regular text-secondary",
                styles.gap,
              )}
            >
              <div>{fullName}</div>
              <div>{country && getName(country)}</div>
              <div className={classNames(!addressLineFirst && "d-none")}>
                {addressLineFirst}
              </div>
              <div className={classNames(!addressLineSecond && "d-none")}>
                {addressLineSecond}
              </div>
              <div className={classNames(!city && !state && "d-none")}>
                {city && state ? `${city}, ${state}` : city ? city : state}
              </div>
              <div className={classNames(!postalCode && "d-none")}>
                {postalCode}
              </div>
            </div>
          </>
        )}
        <div>
          <div className="subtitle-2 text-medium mb-2 text-primary">
            {t("CARD_DETAILS")}
          </div>
          <div className="w-100 text-body-1 text-regular">
            <div className={classNames("d-flex mb-1 text-primary", styles.gap)}>
              <div>{paymentSystem}</div>
              {`**** ${lastFourNumbers}`}
            </div>
            <div className="text-tertiary">
              {t("EXPIRES", {
                expMonth,
                expYear: `${expYear}`.slice(-2),
              })}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentCardDetails;
